import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { CANNED_RESPONSE_DELETE_PERMISSION } from "components/dashboard/KnowledgeBase/CannedResponses/permissions";

const CRTableDropdown = ({ handleActionModal }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={() => handleActionModal?.()}
            options={[
                {
                    value: "DELETE",
                    label: "Delete",
                    baseResources: CANNED_RESPONSE_DELETE_PERMISSION,
                },
            ]}
        />
    );
};

export default CRTableDropdown;
